import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Header from '../header/Header';
import MenuCompany from '../menu/MenuCompany';
import red_line from '../../img/red_line.png';
import '../complaintSummary/ComplaintSummary.css';
import { useNavigate } from 'react-router-dom'; 
import { useEffect } from 'react';
import { issueComplaint } from '../../features/complaint/ComplaintSlice';
import { MobileMenuCompany } from '../mobileMenu/MobileMenuCompany';
import ReCAPTCHA from 'react-google-recaptcha';
import { getCaptchaSiteKey, validateCaptcha } from '../../features/captcha/CaptchaSlice';
import { IS_INTERNAL_APP } from '../../api/ApiSettings';
import { LoadingSpinner } from '../common/loadingSpinner/LoadingSpinner';
import moment from 'moment';

export const CompanyComplaintSummary = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isMobile, setIsMobile] = useState(window.matchMedia("(max-width: 600px)").matches);   
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(window.location.pathname);
  const customer = useSelector((state) => state.customer)
  const customerId= customer.type.customerId;
  const complaint = useSelector((state) => state.complaint);
  const positions = useSelector((state)=>state.complaintPositions.positions);
  const selectedCompany = useSelector((state)=>state.company.selectedRow);
  const selectedRecipientAddress = useSelector(state=>state.company.selectedAddress);
  const targetCustomer = useSelector(state=>state.targetCustomer);
  const complaintTypeName = useSelector((state)=>state.complaint.complaintType.name);
  const complaintType = useSelector((state)=>state.complaint.complaintType);
  const captchaSiteKey = useSelector((state)=>state.captcha.captchaSiteKey);
  const captchaValidateResult = useSelector((state)=>state.captcha.validationResult);
  const [dataProcessingAgreement, setDataProcessingAgreement] = useState(false);
  const hasAttachments = useSelector((state)=>state.attachment.hasAttachments);
  const [submitButtonClicked, setSubmitButtonClicked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  useEffect(()=>{
    dispatch(getCaptchaSiteKey());
  },[dispatch]); 

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   if (targetCustomer.street === "" || complaint.complaintType.id === 0) {
  //     setCurrentPage('unsend');
  //     navigate('/unsend');
  //   }
  //   if (submitting) {
  //     return; 
  //   }
  //   setSubmitting(true);
  //   setSubmitButtonClicked(true);
  //   if (complaintType.displayName === 'Nieokreślony' && complaintType.name === 'NotSpecified' && complaintType.id === 0) {
  //     setCurrentPage('unsend');
  //     navigate('/unsend');
  //   }
  //   if(customerTypeId === 0 || customerTypeIds === 0){
  //     setCurrentPage('unsend');
  //     navigate('/unsend');
  //   }
  //   try {
  //     if (IS_INTERNAL_APP === false && (captchaValidateResult === true && dataProcessingAgreement === true && positions.length > 0)) {
  //       setLoading(true); 
  //       await dispatch(issueComplaint());
  //       setCurrentPage('send');
  //       navigate('/send');
  //     } else if (IS_INTERNAL_APP === true && positions.length > 0) {
  //       setLoading(true);
  //       await dispatch(issueComplaint());
  //       setCurrentPage('send');
  //       navigate('/send');
  //     }
  //   } finally {
  //     setSubmitting(false);
  //   }
  // };

  //ZMIENIONO 
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (submitting) return; 

    setSubmitting(true);
    setSubmitButtonClicked(true);

    if (complaintType.displayName === 'Nieokreślony' && complaintType.name === 'NotSpecified' && complaintType.id === 0) {
        alert("Nie można wysłać zgłoszenia. Typ zgłoszenia jest niepoprawny.");
        setSubmitting(false);
        return;
    }
   if (targetCustomer.street === "" || !complaint.complaintType || complaint.complaintType.id === 0) {
      alert("Nie udało się zapisać zgłoszenia – brak wymaganych danych.");
      setSubmitting(false);
      return;
    }

    const canSubmit = IS_INTERNAL_APP 
        ? positions.length > 0
        : (captchaValidateResult && dataProcessingAgreement && positions.length > 0);

    if (!canSubmit) {
        alert ("Nie udało się zapisać zgłoszenia – wymagana weryfikacja CAPTCHA i zgoda na przetwarzanie danych.");
        setSubmitting(false);
        return;
    }

    try {
        setLoading(true);
        const response = await dispatch(issueComplaint()).unwrap();
       
        if (!response || response.error) {
            throw new Error(response?.error || "Błąd serwera. Spróbuj ponownie później.");
        }

        setCurrentPage('send');
        navigate('/send');

    } catch (error) {
        console.error("Błąd podczas wysyłania zgłoszenia:", error);
        // alert("Nie udało się wysłać zgłoszenia. Spróbuj ponownie później.");
        setCurrentPage('unsend');
        navigate('/unsend');
    } finally {
        setSubmitting(false);
        setLoading(false);
    }
};


  useEffect(() => {
    const handleWindowResize = () => {
        setIsMobile(window.matchMedia("(max-width: 767px)").matches);
    };
    window.addEventListener("resize", handleWindowResize);
    return () => {
        window.removeEventListener("resize", handleWindowResize);
    };
}, []);

useEffect(() => {
    function handlePageChange() {
        setCurrentPage(window.location.pathname);
    }
    window.addEventListener("popstate", handlePageChange);
    return () => {
        window.removeEventListener("popstate", handlePageChange);
    };
}, [currentPage]);
const handleBackClick = () =>{
  setCurrentPage('companyReceiptGoods');
  navigate('/companyReceiptGoods');  
}
const handleCaptchaValidation = (captchaResponse) =>{
  dispatch(validateCaptcha(captchaResponse));
}
const handleAgreementCheckboxChange = (event) => {
  setDataProcessingAgreement(event.target.checked);
};


return (
    <div className='page-size'>
        <Header/>
        {isMobile ? <MobileMenuCompany isOpen={isMenuOpen} onClick={() => setIsMenuOpen(!isMenuOpen)}/> : <MenuCompany isOpen={isMenuOpen} onClick={() => setIsMenuOpen(!isMenuOpen)}/>}
          <div className='summary-container'>
          <div className="complaint-summary-title">
            <img style={{marginLeft: "0px"}} src={red_line} className='red-line'/>
            <p className='complaint-summary-text'>Podsumowanie</p>
          </div>
           <form  onSubmit={handleSubmit}>
               <div className='information-contaner'>
                  <p className='containers-title'>Informacje podstawowe</p>
                  <div className='conitainers-information-title'>
                    <p>Rodzaj zgłoszenia<br/><p className='conitainers-information-text'>{complaint.complaintType.displayName}</p></p><br/>
                    <p>Data utworzenia<br/><p className='conitainers-information-text'>{moment(complaint.createDate).format('YYYY-MM-DD')}</p></p>
                  </div>
                  <br/>
               </div>
               <div className='client-data'>
                  <p className='containers-title'>Dane firmy</p>
                  <div className='conitainers-information-title'>
                    <p>Nazwa firmy</p><p className='conitainers-information-text'>
                      {selectedCompany ? selectedCompany.companyName : '-'}
                    </p>
                    <p>NIP</p><p className='conitainers-information-text'>
                      {selectedCompany ? selectedCompany.companyTax : '-'}
                    </p>
                    <p>Adres</p>
                    <div className='conitainers-information-text'>
                    <p>{selectedCompany ? `${selectedCompany.fullAddress} ${selectedCompany.flatNumber}` : '-'}</p>
                    <p>{selectedCompany ? selectedCompany.postalCode : '-'} {selectedCompany ? selectedCompany.city : '-'}</p>
                    <p>Polska</p>
                    </div>
                  </div>
               </div><br/>
               <div className='client-data'>
                  <p className='containers-title' style={{marginTop:'180px'}}>Dane osoby zgłaszającej</p>
                  <div className='conitainers-information-title'>
                    <p>Imię i nazwisko</p><p className='conitainers-information-text'>{targetCustomer.customerPersonName}</p>
                    <p>E-mail</p><p className='conitainers-information-text'>{targetCustomer.email}</p>
                    <p>Telefon</p><p className='conitainers-information-text'>{targetCustomer.phone}</p>
                    <p>Miejsce odbioru towaru</p>
                    <div className='conitainers-information-text'>
                        <p>{targetCustomer.street} {targetCustomer.buildingNumber}</p>
                        <p>{targetCustomer.postalCode} {targetCustomer.city}</p>
                        <p>Polska</p>
                    </div>
                  </div>
               </div><br/>
               <div className='complaint-products' style={{marginTop:'450px', listStyle:'none'}}>
                  <p className='containers-title'>Produkty zgłoszone do reklamacji</p>
                  {positions.map((position, index)=>(
                  <div className='complaint-products-container'>
                  <div>
                      <li className='complaint-products-title' key={index} style={{marginLeft:'30px'}}>{position.product.name}</li>
                  </div>
                    {/* <p className='complaint-products-title'>{selectedRow.name}</p> */}
                  <div className='complaint-products-data'>
                    <div className='frame-815'>
                    <div className='product-data-title' style={{whiteSpace:"nowrap"}}>
                        {(()=>{
                                  switch (complaintTypeName) {
                                      case 'Warranty':
                                      return(
                                        <div>
                                          <p className='frame-for-text'>Indeks <p className='product-data-text'>{position.product.code}</p></p>
                                          <p className='frame-for-text'>Opis wady fizycznej <p className='product-data-text'>{position.faultDescription}</p></p>
                                          <p className='frame-for-text'>Data wykrycia wady <p className='product-data-text'>{moment(position.faultDate).format('YYYY-MM-DD')}</p></p>
                                          <p className='frame-for-text'>Okoliczności wykrycia wady <p className='product-data-text'>{position.faultDiscoveryCircumstances}</p></p>
                                          <p className='frame-for-text'>Oczekiwania reklamującego <p className='product-data-text'>{position.customerRequest}</p></p>
                                          <p className='frame-for-text'>Numer dokumentu sprzedaży <p className='product-data-text'>{position.salesDocumentNumber}</p></p>
                                          <p className='frame-for-text'>Sposób wysyłki produktu <p className='product-data-text'>{position.shippingMethod.displayName}</p></p>
                                          <p className='frame-for-text'>Uwagi <p className='product-data-text'>{position.notes}</p></p>
                                        </div> 
                                      );
                                      
                                      case 'SalesWarranty':
                                      return(
                                        <div>
                                          <p className='frame-for-text'>Indeks <p className='product-data-text'>{position.product.code}</p></p>
                                          <p className='frame-for-text'>Opis wady fizycznej <p className='product-data-text'>{position.faultDescription}</p></p>
                                          <p className='frame-for-text'>Data wykrycia wady <p className='product-data-text'>{moment(position.faultDate).format('YYYY-MM-DD')}</p></p>
                                          <p className='frame-for-text'>Okoliczności wykrycia wady <p className='product-data-text'>{position.faultDiscoveryCircumstances}</p></p>
                                          <p className='frame-for-text'>Numer dokumentu sprzedaży <p className='product-data-text'>{position.salesDocumentNumber}</p></p>
                                          <p className='frame-for-text'>Opis przesyłki <p className='product-data-text'>{position.shipmentDescription}</p></p>
                                          <p className='frame-for-text'>Sposób wysyłki produktu <p className='product-data-text'>{position.shippingMethod.displayName}</p></p>
                                          <p className='frame-for-text'>Uwagi <p className='product-data-text'>{position.notes}</p></p><br/>
                                        </div> 
                                      );
                                  
                                      case 'DeliveryMismatch':
                                      return(
                                        <div>
                                          <p className='frame-for-text'>Indeks <p className='product-data-text'>{position.product.code}</p></p>
                                          <p className='frame-for-text'>Ilość według faktury <p className='product-data-text'>{position.invoiceQuantity}</p></p>
                                          <p className='frame-for-text'>Dostarczona ilość <p className='product-data-text'>{position.shippedQuantity}</p></p>
                                          <p className='frame-for-text'>Numer dokumentu sprzedaży <p className='product-data-text'>{position.salesDocumentNumber}</p></p>
                                          <p className='frame-for-text'>Pozycja na dokumencie sprzdaży <p className='product-data-text'>{position.salesDocumentPosition}</p></p>
                                          <p className='frame-for-text'>Sposób rozpatrzenia reklamacji <p className='product-data-text'>{position.quantityCorrectionsProposal.displayName}</p></p>
                                          <p className='frame-for-text'>Uwagi <p className='product-data-text'>{position.notes}</p></p><br/>
                                        </div> 
                                      );
                                      
                                      case 'PayedRepair':
                                      return(
                                        <div>
                                          <p className='frame-for-text'>Indeks <p className='product-data-text'>{position.product.code}</p></p>
                                          <p className='frame-for-text'>Opis wady fizycznej <p className='product-data-text'>{position.faultDescription}</p></p>
                                          <p className='frame-for-text'>Data wykrycia wady <p className='product-data-text'>{moment(position.faultDate).format('YYYY-MM-DD')}</p></p>
                                          <p className='frame-for-text'>Okoliczności wykrycia wady <p className='product-data-text'>{position.faultDiscoveryCircumstances}</p></p>
                                          <p className='frame-for-text'>Sposób wysyłki produktu <p className='product-data-text'>{position.shippingMethod.displayName}</p></p>
                                          <p className='frame-for-text'>Opis przesyłki<p className='product-data-text'>{position.shipmentDescription}</p></p>
                                          <p className='frame-for-text'>Uwagi <p className='product-data-text'>{position.notes}</p></p><br/>
                                        </div> 
                                      );

                                      case 'UnderWarrantyLaserDeviceCalibration':
                                      return(
                                        <div>
                                          <p className='frame-for-text'>Indeks <p className='product-data-text'>{position.product.code}</p></p>
                                          <p className='frame-for-text'>Opis wady fizycznej <p className='product-data-text'>{position.faultDescription}</p></p>
                                          <p className='frame-for-text'>Data wykrycia wady <p className='product-data-text'>{moment(position.faultDate).format('YYYY-MM-DD')}</p></p>
                                          <p className='frame-for-text'>Numer dokumentu sprzedaży <p className='product-data-text'>{position.salesDocumentNumber}</p></p>
                                          <p className='frame-for-text'>Opis przesyłki <p className='product-data-text'>{position.shipmentDescription}</p></p>
                                          <p className='frame-for-text'>Sposób wysyłki produktu <p className='product-data-text'>{position.shippingMethod.displayName}</p></p>
                                          <p className='frame-for-text'>Uwagi <p className='product-data-text'>{position.notes}</p></p><br/>
                                        </div> 
                                      );

                                      case 'TransportDamage':
                                      return(
                                        <div>
                                          <p className='frame-for-text'>Indeks <p className='product-data-text'>{position.product.code}</p></p>
                                          <p className='frame-for-text'>Ilość <p className='product-data-text'>{position.amount}</p></p>
                                          <p className='frame-for-text'>Opis wady fizycznej <p className='product-data-text'>{position.faultDescription}</p></p>
                                          <p className='frame-for-text'>Numer dokumentu sprzedaży <p className='product-data-text'>{position.salesDocumentNumber}</p></p>
                                          <p className='frame-for-text'>Pozycja na dokumencie sprzdaży <p className='product-data-text'>{position.salesDocumentPosition}</p></p>
                                          <p className='frame-for-text'>Data przyjęcia przesyłki <p className='product-data-text'>{moment(position.dateOfReceiptOfGoods).format('YYYY-MM-DD')}</p></p>
                                          <p className='frame-for-text'>Przewoźnik <p className='product-data-text'>{position.courier.displayName}</p></p>
                                          <p className='frame-for-text'>Uwagi <p className='product-data-text'>{position.notes}</p></p><br/>
                                        </div> 
                                      );

                                      case 'PostWarrantyLaserDeviceCalibration':
                                      return(
                                        <div>
                                          <p className='frame-for-text'>Indeks <p className='product-data-text'>{position.product.code}</p></p>
                                          <p className='frame-for-text'>Opis wady fizycznej <p className='product-data-text'>{position.faultDescription}</p></p>
                                          <p className='frame-for-text'>Sposób wysyłki produktu <p className='product-data-text'>{position.shippingMethod.displayName}</p></p>
                                          <p className='frame-for-text'>Opis przesyłki <p className='product-data-text'>{position.shipmentDescription}</p></p>
                                          <p className='frame-for-text'>Uwagi <p className='product-data-text'>{position.notes}</p></p><br/>
                                        </div> 
                                      );
                                      
                                      default:
                                          break;
                                        }
                                    })()}
                                     <br/>
                                      {hasAttachments && (
                                      <div className='list-with-files'>
                                        <p>Klient dodał załączniki do zgłoszenia:</p>
                                        <ul style={{listStyle:'circle', fontWeight:'normal'}}>
                                          {position.files && position.files.map((file, fileIndex) => (
                                            <li key={fileIndex}>
                                              <p>{file.name}</p>
                                            </li>
                                          ))}
                                        </ul>
                                      </div>
                                    )}
    
                    </div> 
                  </div>
                  </div>
                  </div>))} 
               </div>
            </form>
            <div className="summary-btn-frame" style={{bottom:'-1200px'}}>
              {IS_INTERNAL_APP === false && 
              <>
              <div className="summary-btn-frame-element">
              <input
                type="checkbox"
                checked={dataProcessingAgreement}
                onChange={handleAgreementCheckboxChange}
              />
              <label
                htmlFor="regulamin"
                style={{ color: submitButtonClicked && !dataProcessingAgreement  ? 'red' : 'black' }}
              >
                Wyrażam zgodę na przetwarzanie przez Pro Sp.z.o.o. moich danych osobowych w celu przeprowadzenia procesu związanego z złożeniem i obsługą zgłoszenia, utworzonego w aplikacji internetowej.*
              </label>
            </div>
              <div className="summary-btn-frame-element">
              {captchaSiteKey && (
                  <ReCAPTCHA
                    sitekey={captchaSiteKey}
                    onChange={(captchaResponse) => handleCaptchaValidation(captchaResponse)}
                  />
                )}
              </div>
              </>}
              <div className="summary-buttons"> 
                <button className="summary-prev-btn" onClick={handleBackClick}><p className="navigation-button-back-text">Wróć</p></button>
                <button className="summary-send-btn" style={{width: '200px'}} onClick={handleSubmit} disabled={loading}><p className='btn-send-complaint'>Wyślij zgłoszenie</p>
                {loading && 
                    <LoadingSpinner/>
                  }
                </button>
              </div>
          </div>

          </div>
    </div>
  )
}
